<template> 
    <v-dialog v-model="dialog" max-width="300px" v-bind:persistent="true"> 
        <v-card> 
            <slot name="title"></slot>
            <slot name="error-text"></slot>
            <slot name="success-text"></slot>
            <v-card-actions class="button-center"> 
                <v-btn class="confirm" @click.stop="ok">Ok</v-btn> 
            </v-card-actions> 
        </v-card> 
    </v-dialog> 
</template> 
 
<script>
    export default {
        name: 'information-dialog',
        data() {
            return {
                dialog: true
            };
        },
        methods: {
            ok() {
                this.$emit('ok');
            }
        }
    };
</script>

<style scoped>
    .confirm {
        margin: 0 auto;
    }
    .button-center {
        justify-content: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/reusable/information-dialog.vue